module.exports = __webpack_public_path__ + "media/images/icons/chevron-left-5a576cdde127b36b17577999b7becb6b.svg";